export default __webpack_public_path__ + "static/media/020309202112105.52af09f3.png";